import { Box, SvgIcon, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import React, { forwardRef } from 'react'

import InfoIcon from '@hapana/shared/web/styles/assets/svgs/info-small.svg'

import TableToolbar from './table-toolbar/table-toolbar.component'
import { handleStylesWithProps, styles } from './../table.styles'

const TableHeader = forwardRef(
  (
    {
      title,
      description,
      hasToolbar,
      toolbar,
      toolbarWithBorder,
      pagination,
      hidePaginationUI,
      secondaryAction,
      primaryAction,
      otherActions,
      helperText,
      customActions,
      filterProps,
      areAllFiltersDisabled,
      customHeaderStyles,
    },
    ref
  ) => {
    const headerBaseStyles = customHeaderStyles ?? styles.headerContainer
    const dynamicHeaderStyles = handleStylesWithProps({
      toolbarWithBorder,
    }).headerContainer
    return (
      <Box sx={[headerBaseStyles, dynamicHeaderStyles]}>
        <Box style={styles.titleDescStyles}>
          {typeof title === 'object' ? title : <Typography sx={styles.title}>{title}</Typography>}
          {typeof title === 'object' ? (
            description
          ) : (
            <Typography sx={styles.description}>{description}</Typography>
          )}
        </Box>
        {hasToolbar && (
          <TableToolbar
            toolbar={toolbar}
            toolbarWithBorder={toolbarWithBorder}
            pagination={pagination}
            hidePaginationUI={hidePaginationUI}
            secondaryAction={secondaryAction}
            primaryAction={primaryAction}
            title={title}
            description={description}
            ref={ref}
            otherActions={otherActions}
            customActions={customActions}
            filterProps={filterProps}
            areAllFiltersDisabled={areAllFiltersDisabled}
          />
        )}
        {helperText && (
          <Box sx={styles.helperText}>
            <SvgIcon component={InfoIcon} sx={styles.infoIcon} />
            <Typography variant="body2" color="gray.80">
              {helperText}
            </Typography>
          </Box>
        )}
      </Box>
    )
  }
)

TableHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  hasToolbar: PropTypes.bool.isRequired,
  toolbar: PropTypes.node,
  pagination: PropTypes.object,
  hidePaginationUI: PropTypes.bool.isRequired,
  secondaryAction: PropTypes.object,
  primaryAction: PropTypes.object,
  helperText: PropTypes.string,
  otherActions: PropTypes.array,
  customActions: PropTypes.node,
  filterProps: PropTypes.object,
  areAllFiltersDisabled: PropTypes.bool,
  customHeaderStyles: PropTypes.object,
}

TableHeader.defaultProps = {
  toolbarWithBorder: false,
}

export default TableHeader
